export enum ErrorTypeEnum {
  CALCULATOR_MINIMUM_TREATMENT_PERIOD = 'CalculatorMinimumTreatmentPeriod',
  CALCULATOR_MAXIMUM_TREATMENT_PERIOD = 'CalculatorMaximumTreatmentPeriod'
}
